import React, {createContext, useReducer, useState} from 'react';
import {SubtitleReducer} from "../reducers/SubtitleReducer";
import { useLocation } from 'react-router-dom';
import TimeUtils from "../helper/TimeUtils";
import SubTitleUtils from "../helper/SubTitleUtils";
import FindAllView_replace from "../components/translations/TranslationsView";

export const SubtitleContext = createContext();

const SubtitleContextProvider = (props) =>{
    const location = useLocation();


    //設定Table的選擇index 用在點兩下
    const [SelectedTableRowIndex,setSelectedTableRowIndex] = useState(0);

    //要紀錄的資料
    const [befoCellChangeData,setbefoCellChangeData] = useState([]);


    const [ccEnable,setccEnable] = useState(true);
    //const [subTitle,setsubTitle] = useState("");
    const [rowIndex,setrowIndex] = useState(0);

    //設定頻率
    const [videoFps,setvideoFps] = useState(0);
    const [frameWidth,setframeWidth] = useState(0);

    //拖拉過來的時間
    const [videoCurrentTime_byDrag,setvideoCurrentTime_byDrag] = useState(0);
    const [videoCurrentTime_byCtrlRight,setvideoCurrentTime_byCtrlRight] = useState([]);


    const [{isPlayerStart,way,SubtitleData,handleDragValue,DragData,subTitle,findFrameSplitValue,fFrameSplit,CtrlZ,blue_row},dispatch] =
        useReducer(SubtitleReducer,{
            isPlayerStart:{
                isPlay:false,
                StopTime:0
            },
            handleDragValue:0,
            PlayerCurrentTime:0,
            blue_row:0,
            findFrameSplitValue:2,
            fFrameSplit:2,
            CtrlZ:[],
            SubtitleData:[],
            DragData:[],
            subTitle:"",
            way:0
        });


    //增加距離
    const sethandleDragValue = (handleDragValue)=>{
        if(isPlayerStart.isPlay=== true){
            dispatch({
                type: "SET_handleDragValue",
                payload: handleDragValue
            });
        }
    }


    //設定開始或結束
    const setisPlayerStart = (newisPlayerStart,newhandleDragValue)=>{
        // console.log(`isPlayerStart ${JSON.stringify(newisPlayerStart)} `);

        dispatch({
            type: "SET_isPlayerStart",
            payload: newisPlayerStart
        });

        //StopTime
        dispatch({
            type: "SET_handleDragValue",
            payload: newhandleDragValue
        });
    }


    //增加上一步驟
    const addCtrlZ = (newStep)=>{
        let newCtrlZ = CtrlZ;
        newCtrlZ.push(newStep);
        dispatch({
            type: "SET_CtrlZ",
            payload: newCtrlZ
        });
    }

    //移除最後一步驟
    const removeCtrlZ = ()=>{
        let newCtrlZ = CtrlZ;
        newCtrlZ.pop();
        dispatch({
            type: "SET_CtrlZ",
            payload: newCtrlZ
        });
    }

    const setway = (way)=>{
        dispatch({
            type: "SET_way",
            payload: way
        });
    }
　
    //設定使用者選中的row
    const setblue_row = (blue_row)=>{

        dispatch({
            type: "SET_blue_row",
            payload: blue_row
        });
    }

    //設定當前字幕跟當前index 主要服務在點擊pause按鈕上面
    const updateSubTitle_by_row = async (by_rowIndex)=>{

        //設定index
        await setrowIndex(by_rowIndex);

        //取出字幕 更新
        if(SubtitleData.length !== 0){
            const currentRowData = SubtitleData[by_rowIndex];
            const newSubtitleCaption = currentRowData.SubtitleCaption;
            const newPosition = currentRowData.Position;

            // console.log(`更新字幕 ${by_rowIndex} ${newSubtitleCaption}`);
            if(newSubtitleCaption !== subTitle){
                dispatch({
                    type: "SET_subTitle",
                    payload: newSubtitleCaption
                });
            }
            if(newPosition !== way){
                //way的調整
                dispatch({
                    type: "SET_way",
                    payload: newPosition
                });
            }
        }

    }

    //主要透過影片播放的時間來判斷顯式字幕
    const updateSubTitle_by_row_frame = async (currentDataIndex,curentFrame)=>{

        // In(pin):"00:00:00.22"
        // Out(pin):"00:00:01.17"
        // ShotChange(pin):""
        // Duration(pin):0.79
        // Memo(pin):"1222"
        // Source(pin):" ROOMCA MP23"
        // SubtitleCaption(pin):"ROOMCA MP23www"
        // Length(pin):"3 3.5"
        // Position(pin):""

        //設定index
        await setrowIndex(currentDataIndex);
　

        //取出字幕 更新
        if(SubtitleData.length !== 0){
            const currentRowData = SubtitleData[currentDataIndex];
            const {SubtitleCaption,Position,In,Out} = currentRowData;


            //時間內
            if(curentFrame >= In && curentFrame <= Out ){
                if(SubtitleCaption !== subTitle){
                    dispatch({
                        type: "SET_subTitle",
                        payload: SubtitleCaption
                    });
                }

                if(Position !== way){
                    //way的調整
                    dispatch({
                        type: "SET_way",
                        payload: Position
                    });
                }
            }else{
                //時間外　
                dispatch({
                    type: "SET_subTitle",
                    payload: ""
                });
            }
        }
    }

    const setfindFrameSplitValue = (findFrameSplitValue)=> {
        localStorage.setItem('findFrameSplitValue', findFrameSplitValue);
        dispatch({
            type: "SET_findFrameSplitValue",
            payload: findFrameSplitValue
        });
    }

    const setfFrameSplit = (fFrameSplit)=> {
        localStorage.setItem('fFrameSplit', fFrameSplit);
        dispatch({
            type: "SET_fFrameSplit",
            payload: fFrameSplit
        });
    }

    const initSubAndDragData = ()=>{
        let subtitleData = [];
        subtitleData = SubTitleUtils.geinitSubtitleData(videoFps);
        if(subtitleData.length === 0){
            dispatch({
                type: "SET_SubtitleData",
                payload:[]
            });
        }else{
            dispatch({
                type: "SET_SubtitleData",
                payload:subtitleData
            });
        }

       //console.log(`初始拖拉資料 subtitleData ${JSON.stringify(subtitleData[0])}`);

        //初始拖拉資料
        // const DragData = SubTitleUtils.getInitDragData(videoFps,frameWidth,300);
        //
        //  dispatch({
        //     type: "SET_DragData",
        //     payload:DragData
        // });

       // console.log(`初始拖拉資料 ${JSON.stringify(DragData)}`);

    }

    return (
        <SubtitleContext.Provider value={{
            SubtitleData,
            way,
            setway,

            subTitle,　
            updateSubTitle_by_row,
            updateSubTitle_by_row_frame,

            DragData,

            ccEnable,setccEnable,

            setvideoFps,
            setframeWidth,
            initSubAndDragData,

            findFrameSplitValue,
            setfindFrameSplitValue,

            fFrameSplit,
            setfFrameSplit,

            SelectedTableRowIndex,
            setSelectedTableRowIndex,

            blue_row,
            setblue_row,

            //上一步功能
            befoCellChangeData,
            setbefoCellChangeData,

            //拖拉功能
            videoCurrentTime_byDrag,
            setvideoCurrentTime_byDrag,

            //播放時間
            isPlayerStart,
            setisPlayerStart,
            handleDragValue,
            sethandleDragValue,

            //播放開關
            // isPlayVideo,
            // setisPlayVideo,

            //表單控制
            videoCurrentTime_byCtrlRight,
            setvideoCurrentTime_byCtrlRight,

            dispatch
        }}>
            {props.children}
        </SubtitleContext.Provider>
    );
}

// this.props.setTableData
//
// <SubtitleContext.Consumer>
//     {context =>
//         <FindAllView_replace context={context} />
//     }
// </SubtitleContext.Consumer>
//
// 

export default SubtitleContextProvider;





// WEBPACK FOOTER //
// ./src/contexts/SubtitleContext.js